import Vue from 'vue';
import App from './App.vue';
import Axios from 'axios';
import router from './router';
import vuetify from './plugins/vuetify';
import i18n from './i18n';
import DatetimePicker from 'vuetify-datetime-picker';
import './registerServiceWorker'

// local custom imports
import CDNCONFIG from './cdn/cdn.config';
import COREAPI from './cdn/cdn.api';

Vue.use(DatetimePicker);

Vue.prototype.$cdnConfig = CDNCONFIG;
Vue.prototype.$api = COREAPI;

// global access to axios
Vue.prototype.$http = Axios;


Vue.config.productionTip = false;

new Vue({
	router,
	vuetify,
	i18n,
	render: h => h(App)
}).$mount('#app');
